
import * as React from 'react';
const { Component } = React;
type ReactNode = React.ReactNode;
type ErrorInfo = React.ErrorInfo;
import { criticalLogger } from '@/utils/logger';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export default class ModalErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    criticalLogger.error('Modal Error Boundary caught error:', error);
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    criticalLogger.error('Modal Error Boundary details:', { error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg max-w-sm mx-4">
            <h3 className="text-lg font-semibold mb-2">Modal Error</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
              There was an error rendering the modal. Please try again.
            </p>
            <button 
              onClick={() => this.setState({ hasError: false })}
              className="bg-gold text-black px-4 py-2 rounded"
            >
              Try Again
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
